// src/components/digital_twin/assetHealthCache.js
// --- UPDATE: v1.0 — shared asset-health cache (no 3D / react-three dependencies)
// Split out of AssetHealthIndicator.js so pages can prime the cache without
// importing @react-three/drei (which AssetHealthIndicator needs for <Html>).
//   getCachedAssetHealth(id)   TTL cache + in-flight de-duplication
//   primeAssetHealthCache(map) seed from a bulk health response
import { getAssetHealth } from '../../services/predictiveFailureService';

const HEALTH_TTL_MS = 60000;
const healthCache = new Map();   // assetId -> { data, ts }
const healthInflight = new Map(); // assetId -> Promise

export const getCachedAssetHealth = async (assetId, { force = false } = {}) => {
  const key = String(assetId);
  const hit = healthCache.get(key);
  if (!force && hit && Date.now() - hit.ts < HEALTH_TTL_MS) return hit.data;
  if (healthInflight.has(key)) return healthInflight.get(key);
  const p = getAssetHealth(assetId)
    .then((data) => { healthCache.set(key, { data, ts: Date.now() }); return data; })
    .finally(() => healthInflight.delete(key));
  healthInflight.set(key, p);
  return p;
};

/** Seed the cache from a bulk response ({ [assetId]: health }) so indicators skip their fetch. */
export const primeAssetHealthCache = (healthMap = {}) => {
  const ts = Date.now();
  Object.entries(healthMap || {}).forEach(([id, data]) => { if (data) healthCache.set(String(id), { data, ts }); });
};
// --- END UPDATE